// Grouped for organization
const technicianEndpoints = {
  TECHNICIANS: 'loopay-technician-management/technicians',
  TECHNICIANS_SCHEDULE: 'loopay-technician-management/technicians/schedule',
  PRESIGNED_URLS_BATCH: 'loopay-media-management/media/presigned-urls/batch',
  MEDIA_RESOURCES: 'loopay-media-management/media/resources',
  UPLOAD_S3: '', // Dynamic S3 URL from presigned response
} as const;

// Default export for bulk imports (optional)
export default technicianEndpoints;
